import React from 'react'
import Helpers from '../../../helpers/shared.helper';
import FieldValidity from '../../../services/fieldValidity.service';

const SharedPhone = ({ placeholder="", name="phone", id="phone", classname="storefront-phone-field", phone, updateContactInput = () => { },updateContactField = () => {}, HBB = false }) => {
    const checkContactField = (val) => {
        let validationData = HBB ? Helpers.commonPhoneValidateCheckerHBB(val, phone?.validation) : Helpers.commonPhoneValidateChecker(val, phone?.validation);
        let phoneObj = {
            value: val,
            valid: validationData.valid,
            touched: true,
            error: validationData.errorType
        }
        updateContactField(phoneObj)
    }

    const validateContactField = (event) => {
        checkContactField(event.target.value);
    }

    return (
        <>
            <input
                type="tel"
                className={
                    `${classname} ` +
                    (!phone.touched || (phone.touched && phone.valid)
                        ? "valid"
                        : "invalid") +
                    (phone.value ? " filled" : "")
                }
                name={name}
                id={id}
                value={phone.value}
                onChange={event => {
                    if(HBB === true) {
                        if (FieldValidity.inputDigitsHBB(event, phone.validation.maxLengthValue)) {
                            updateContactInput(event.target)
                        }
                    } else {
                        if (FieldValidity.inputDigits(event, phone.validation.maxLengthValue)) {
                            updateContactInput(event.target)
                        }
                    }
                }}
                onBlur={validateContactField}
                placeholder={placeholder}
            />
            {/* <input
                type="tel"
                className={
                    `${classname} ` +
                    (!phone.touched || (phone.touched && phone.valid)
                        ? "valid"
                        : "invalid") +
                    (phone.value ? " filled" : "")
                }
                name={name}
                id={id}
                value={phone.value}
                onBlur={handleBlur}
                onChange={event => {
                    if (FieldValidity.inputDigits(event, 10)) {
                        // Update value on change but don't validate here
                        updateContactInput({
                            ...phone,
                            value: event.target.value,
                            // touched: phone.touched
                        });
                    }
                }}
                placeholder={placeholder}
            /> */}
        </>
    );
};

export default SharedPhone;